import { Popover } from 'module/ui/components/atoms/popover';
import styled from 'styled-components';
import { DocumentTitleInput } from './input';

const Title = styled.div<{ $isDisabled: boolean }>`
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
`;

interface Props {
  value: string;
  onChange: (value: string) => void;
  renderTitle?: (value: string) => React.ReactNode;
  isDisabled?: boolean;
}

export const DocumentTitle = ({
  value,
  onChange,
  renderTitle,
  isDisabled = false,
}: Props) => {
  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      content={<DocumentTitleInput value={value} onChange={onChange} />}
      isDisabled={isDisabled}
    >
      <Title $isDisabled={isDisabled}>{renderTitle?.(value) ?? value}</Title>
    </Popover>
  );
};
